import type { ApplicationData } from "./applicationState";

export type CoApplicantStepKey =
  | "authorizationToAssist"
  | "memberProfiles"
  | "rentalDetails"
  | "studentDetails"
  | "specialNeeds"
  | "specialStatus"
  | "householdIncome"
  | "assets"
  | "financialSummary"
  | "uploadCenter"
  | "reviewSign";

// memberProfiles for the co-applicant slice stores only their identity (first/last/dob/ssn)
export const CO_APPLICANT_STEP_ORDER: CoApplicantStepKey[] = [
  "authorizationToAssist",
  "memberProfiles",
  "rentalDetails",
  "studentDetails",
  "specialNeeds",
  "specialStatus",
  "householdIncome",
  "assets",
  "financialSummary",
  "uploadCenter",
  "reviewSign",
];

export const computeCoApplicantResume = (
  applicationData: ApplicationData
): { completedSteps: number[]; resumeStep: number } => {
  const completedSteps = CO_APPLICANT_STEP_ORDER.flatMap((key, idx) =>
    applicationData[key as keyof ApplicationData] ? [idx] : []
  );
  const firstIncomplete = CO_APPLICANT_STEP_ORDER.findIndex(
    (key) => !applicationData[key as keyof ApplicationData]
  );
  const resumeStep =
    firstIncomplete === -1
      ? CO_APPLICANT_STEP_ORDER.length - 1
      : firstIncomplete;
  return { completedSteps, resumeStep };
};
